import type { Accessor } from "solid-js";
import "./InputError.css";
export const InputError = (props: {
	name: string;
	errors: Accessor<Record<string, string[]>>;
}) => {
	return (
		<div class="gvtui-input-error">
			{props.errors()?.[props.name]?.map((error) => (
				<p>{error}</p>
			))}
		</div>
	);
};
